import { render } from "./DashboardFilters.vue?vue&type=template&id=f5f2ed16&scoped=true"
import script from "./DashboardFilters.vue?vue&type=script&lang=js"
export * from "./DashboardFilters.vue?vue&type=script&lang=js"

import "./DashboardFilters.vue?vue&type=style&index=0&id=f5f2ed16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f2ed16"]])

export default __exports__